import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { account, logo, shopping, menu } from 'assets/images';
import { useDispatch, useSelector } from 'react-redux';
import { getCartTotal } from 'features/cartSlice';

const NavBar = () => {
  const [open, setOpen] = useState(false);
  const { cart, totalQuantity } = useSelector((state) => state.allCart);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCartTotal());
  }, [dispatch, cart]);
  return (
    <nav>
      <div className="flex items-center font-medium justify-around mx-10 md:mx-10 lg:mx-0 xl:mx-0 2xl:mx-0">
        <div className="z-50 lg:w-auto w-full flex flex-row justify-between items-center gap-x-2">
          <img src={logo} alt="logo" width={40} height={40} />
          <p className="text-base">Ashley's Kitchen</p>
          <div className="text-3xl lg:hidden" onClick={() => setOpen(!open)}>
            <img src={menu} alt="logo" name={`${open ? 'close' : 'menu'}`} />
          </div>
        </div>
        <ul className="lg:flex hidden items-center gap-x-4 text-base">
          <li>
            <Link to="/" className="py-7 px-3 inline-block">
              Home
            </Link>
          </li>
          <li>
            <Link to="/Food" className="py-7 px-3 inline-block">
              Foods
            </Link>
          </li>
          <li>
            <Link to="/Drink" className="py-7 px-3 inline-block">
              Drinks
            </Link>
          </li>
          <li>
            <Link to="/Fruits" className="py-7 px-3 inline-block">
              Fruits
            </Link>
          </li>
          <li>
            <Link to="/Dessert" className="py-7 px-3 inline-block">
              Desserts
            </Link>
          </li>
          <li>
            <Link to="/Cart" className="py-7 px-3 inline-block">
              <div className="flex items-center gap-2">
                Cart <img src={shopping} alt={shopping} width={20} />{' '}
                <sup className="text-base bg-[#2E5894] text-white font-bold rounded-full px-2">
                  {totalQuantity}
                </sup>
              </div>
            </Link>
          </li>
          <li>
            <Link to="/Account" className="py-7 px-3 inline-block">
              <div className="flex items-center gap-2">
                Account
                <img src={account} alt={account} width={20} />
              </div>
            </Link>
          </li>
        </ul>
        <div className="lg:flex hidden justify-between gap-x-4">
          <button className="bg-black text-white rounded-xl py-3 px-4 text-sm font-semibold">
            <Link to="/SignIn">Sign In</Link>
          </button>
          <button className="bg-black text-white rounded-xl py-3 px-4 text-sm font-semibold">
            <Link to="/SignUp">Sign Up</Link>
          </button>
        </div>
        {/* Mobile nav */}
        <ul
          className={`
        lg:hidden bg-white fixed w-full top-0 overflow-y-auto bottom-0 py-24 pl-4
        duration-500 ${open ? 'left-0' : 'left-[-100%]'}
        `}
        >
          <li>
            <Link to="/" className="py-4 px-3 inline-block">
              Home
            </Link>
          </li>
          <li>
            <Link to="/Food" className="py-4 px-3 inline-block">
              Foods
            </Link>
          </li>
          <li>
            <Link to="/Drink" className="py-4 px-3 inline-block">
              Drinks
            </Link>
          </li>
          <li>
            <Link to="/Fruits" className="py-4 px-3 inline-block">
              Fruits
            </Link>
          </li>
          <li>
            <Link to="/Dessert" className="py-4 px-3 inline-block">
              Desserts
            </Link>
          </li>
          <li>
            <Link to="/Cart" className="py-4 px-3 inline-block">
              <div className="flex items-center gap-2">
                Cart <img src={shopping} alt={shopping} width={20} />{' '}
                <sup className="text-base bg-[#2E5894] text-white font-bold rounded-full px-2">
                  {totalQuantity}
                </sup>
              </div>
            </Link>
          </li>
          <li>
            <Link to="/Account" className="py-4 px-3 inline-block">
              <div className="flex items-center gap-2">
                Account
                <img src={account} alt={account} width={20} />
              </div>
            </Link>
          </li>
          <div className="py-5 flex flex-col gap-y-4 px-20">
            <button className="bg-black text-white rounded-xl py-3 px-4 text-sm font-semibold">
              <Link to="/SignIn">Sign In</Link>
            </button>
            <button className="bg-black text-white rounded-xl py-3 px-4 text-sm font-semibold">
              <Link to="/SignUp">Sign Up</Link>
            </button>
          </div>
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
